import React from "react";
import "./breadcrumb.scss";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const BreadCrumb = ({ paths }) => {
  return (
    <div className="breadcrumb">
      {paths.map((path, index) => (
        <div key={index}>
          <Link to={path.path} className="breadcrumb-item">
            {path.name}
          </Link>
          {index < paths.length - 1 && (
            <ChevronRight size={14} className="separator" />
          )}
        </div>
      ))}
    </div>
  );
};

export default BreadCrumb;
